import { queryClient } from '@/api/queryClient';
/**
 * Router instance + context type (frontend-map §3.4 — FOUNDATION-owned).
 *
 * The router carries `{ queryClient }` in context so route `loader`s can prefetch
 * via `queryClient.ensureQueryData`. Register the typed router so `Link`/`useParams`
 * are fully type-checked across the app.
 */
import { createRouter } from '@tanstack/react-router';
import { routeTree } from './routeTree.gen';

export interface RouterContext {
  queryClient: typeof queryClient;
}

export const router = createRouter({
  routeTree,
  context: { queryClient } satisfies RouterContext,
  defaultPreload: 'intent',
  scrollRestoration: true,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
